export default {
  pluralLowerCase: 'результати',
  download: 'Завантажити результат',
  sendToEmail: 'Надіслати на email',
  filter: 'Фільтрувати результати',
  hide: 'Сховати результати',
  cancel: 'Скасувати результати'
};
